import { GroupingType } from '~/_shared/types/grouping/grouping';
import type { SpreadsheetColumnId } from '~/_shared/types/spreadsheetData/spreadsheetColumn';
import { DataType } from '~/store/spreadsheetData/spreadsheetData.state';
import type {
  MapSettingsColumnsFilterState,
  MapSettingsFilterAttributeState,
  MapSettingsFilterGroupState, MapSettingsFilterTextState,
} from './mapSettingsColumnsFilter.state';

const isMapSettingsFilterGroupStateEmpty = (filter?: MapSettingsFilterGroupState): boolean => (
  !filter
  || (Object.keys(filter).length === 0)
  || (
    Object.keys(filter?.[GroupingType.Text] || {}).length === 0
    && Object.keys(filter?.[GroupingType.Numeric] || {}).length === 0
  )
);

const isMapSettingsFilterTextStateEmpty = (filter?: MapSettingsFilterTextState): boolean => (
  !filter || filter.values.length === 0
);

const isMapSettingsFilterAttributeStateEmpty = (filter?: MapSettingsFilterAttributeState): boolean => (
  !filter || (Object.keys(filter.values).length === 0)
);

export const isGroupColumnsFilterEmpty = (
  state: MapSettingsColumnsFilterState,
  spreadsheetColumnId: SpreadsheetColumnId,
): boolean => isMapSettingsFilterGroupStateEmpty(
  state[spreadsheetColumnId.spreadsheetId]?.[spreadsheetColumnId.columnId]?.[DataType.GROUP]
);

export const isTextColumnsFilterEmpty = (
  state: MapSettingsColumnsFilterState,
  spreadsheetColumnId: SpreadsheetColumnId,
): boolean => isMapSettingsFilterTextStateEmpty(
  state[spreadsheetColumnId.spreadsheetId]?.[spreadsheetColumnId.columnId]?.[DataType.TEXT]
);

export const isAttributeColumnsFilterEmpty = (
  state: MapSettingsColumnsFilterState,
  spreadsheetColumnId: SpreadsheetColumnId,
): boolean => isMapSettingsFilterAttributeStateEmpty(
  state[spreadsheetColumnId.spreadsheetId]?.[spreadsheetColumnId.columnId]?.[DataType.ATTRIBUTE]
);
